import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dialogApiInjectionKey as p, dialogProviderInjectionKey as g, dialogReactiveListInjectionKey as v } from "./context.js";
import { NDialogEnvironment as u } from "./DialogEnvironment.js";
import y from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-clicked.js";
import h from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-click-position.js";
import { omit as j } from "../../_utils/vue/omit.js";
import { createId as b } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { defineComponent as k, provide as l, h as d, Fragment as L } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as O, reactive as I } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const P = {
  injectionKey: String,
  to: [String, Object]
}, x = k({
  name: "DialogProvider",
  props: P,
  setup() {
    const t = O([]), o = {};
    function i(e = {}) {
      const r = b(), s = I(Object.assign(Object.assign({}, e), {
        key: r,
        destroy: () => {
          var a;
          (a = o[`n-dialog-${r}`]) === null || a === void 0 || a.hide();
        }
      }));
      return t.value.push(s), s;
    }
    const n = ["info", "success", "warning", "error"].map((e) => (r) => i(Object.assign(Object.assign({}, r), {
      type: e
    })));
    function f(e) {
      const {
        value: r
      } = t;
      r.splice(r.findIndex((s) => s.key === e), 1);
    }
    function m() {
      Object.values(o).forEach((e) => {
        e == null || e.hide();
      });
    }
    const c = {
      create: i,
      destroyAll: m,
      info: n[0],
      success: n[1],
      warning: n[2],
      error: n[3]
    };
    return l(p, c), l(g, {
      clickedRef: y(64),
      clickedPositionRef: h()
    }), l(v, t), Object.assign(Object.assign({}, c), {
      dialogList: t,
      dialogInstRefs: o,
      handleAfterLeave: f
    });
  },
  render() {
    var t, o;
    return d(L, null, [this.dialogList.map((i) => d(u, j(i, ["destroy", "style"], {
      internalStyle: i.style,
      to: this.to,
      ref: (n) => {
        n === null ? delete this.dialogInstRefs[`n-dialog-${i.key}`] : this.dialogInstRefs[`n-dialog-${i.key}`] = n;
      },
      internalKey: i.key,
      onInternalAfterLeave: this.handleAfterLeave
    }))), (o = (t = this.$slots).default) === null || o === void 0 ? void 0 : o.call(t)]);
  }
});
export {
  x as NDialogProvider,
  P as dialogProviderProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/DialogProvider.js
// module id = 329
// module chunks = 67